import React, { useContext, useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

// Components
import Date_Filter from "./Stats_01_Date";
import Delivery_Filter from "./Stats_01_Delivery";
import Name_Filter from "./Stats_01_Name";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 46,
    overflow: "hidden",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
    width: "9rem",
  },
  header1: {
    zIndex: theme.zIndex.mobileStepper,
  },
}));

const DashboardStats_01 = () => {
  const classes = useStyles();

  const {
    selected_fb_details,
    setDisplayContent,
    campaign_stats,
    adset_stats,
    current_tab,
  } = useContext(FacebookProfilesDashboardContext);

  // CREATE BUTTON
  const [createDisabled, setCreateDisabled] = useState(true);

  const onCreate = () => {
    setDisplayContent(current_tab);
  };

  useEffect(() => {
    if (
      selected_fb_details.business_manager &&
      selected_fb_details.ad_account
    ) {
      setCreateDisabled(false);

      if (current_tab === "Ad Set" && campaign_stats.length === 0) {
        setCreateDisabled(true);
      }

      if (current_tab === "Ad" && adset_stats.length === 0) {
        setCreateDisabled(true);
      }
    } else {
      setCreateDisabled(true);
    }
  }, [selected_fb_details, current_tab, campaign_stats, adset_stats]);

  return (
    <TableContainer component={Paper}>
      <Table size="small" stickyHeader className={classes.root}>
        <TableHead>
          <TableRow>
            <TableCell align="left" className={classes.header1}>
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={onCreate}
                disabled={createDisabled}
              >
                Create {current_tab}{" "}
              </Button>{" "}
            </TableCell>
            <TableCell align="right" className={classes.header1}>
              <Name_Filter />
              <Delivery_Filter />
              <Date_Filter />
            </TableCell>{" "}
          </TableRow>{" "}
        </TableHead>{" "}
      </Table>{" "}
    </TableContainer>
  );
};

export default DashboardStats_01;
